/* import __COLOCATED_TEMPLATE__ from './folder-row.hbs'; */
import { getSvgNameForCategory } from '@banking/api/utils/bank-account';
import Component from '@glimmer/component';
export default class FolderRow extends Component {
  get svgNameForAccountCategory() {
    return getSvgNameForCategory(this.args.category);
  }
}